module.exports = __webpack_public_path__ + "static/media/13a-02_Tablas-&-camas-2013-282x176mm-oleo-sobre-revista-National-Geographic-y-madera.1e9fac38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/13a/13a-02_Tablas-&-camas-2013-282x176mm-oleo-sobre-revista-National-Geographic-y-madera.png
// module id = 127
// module chunks = 0